export const SIMILAR_PRODUCTS_SECTION_NAME_FOR_REF = 'similar-products-more-to-explore'
